import React, { createContext, useContext, useState, useEffect } from "react";
import localforage from "localforage";

export type PatientProfile = {
    id: string | null;
    name: string | null;
    email: string | null;
    phone?: string | null;
    dateOfBirth?: string | null;
    bloodType?: string | null;
    emergencyContact?: string | null;
};

export const UserContext = createContext<PatientProfile | null>(null);

export const UserProvider: React.FC<{children: React.ReactNode}> =  ({ children }) => {
    const [profile, setProfile] = useState<PatientProfile>({
        id: null,
        name: null,
        email: null,
        phone: null,
        dateOfBirth: null,
        bloodType: null,
        emergencyContact: null
    });

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                // Get patient id/email from localforage (set after login)
                const patientId = await localforage.getItem("patientId");
                if (!patientId) return;
                // Fetch profile from backend
                const resp = await fetch(`/api/patient/profile/${patientId}`, {
                  credentials: 'include' // <-- critical for cookies
                }); // Adjust endpoint as needed
                if (!resp.ok) return;
                const data = await resp.json();
                setProfile({
                    id: data.id,
                    name: data.name,
                    email: data.email,
                    phone: data.phone,
                    dateOfBirth: data.dateOfBirth,
                    bloodType: data.bloodType,
                    emergencyContact: data.emergencyContact
                });
            } catch (error) {
                console.error("Failed to fetch patient profile:", error);
            }
        };
        fetchProfile();
    }, []);

    return (
        <UserContext.Provider value={profile}>
            {children}
        </UserContext.Provider>
    );
};

export const useUserData = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("useUserData must be used within a UserProvider");
    }
    return context;
};